import Request from "../lib/request";
import {FILES_API} from "../constants/api";
import {PAGE, PER_PAGE} from "../constants/filters";
import {FILES_PER_PAGE} from "../constants/perPage";

const baseUrl = process.env.REACT_APP_API_URL;

export const get = (pageNumber) => {
  return Request({
    method: "get",
    url: `${baseUrl}/${FILES_API}?${PAGE}=${pageNumber}&${PER_PAGE}=${FILES_PER_PAGE}`,
    needToken: true,
  });
};

export const remove = (id) => {
  return Request({
    method: "delete",
    url: `${baseUrl}/${FILES_API}/${id}`,
    needToken: true,
  });
};